import FnButton from '../../../../components/elements/FnButton/index';
import { FnButtonSizes, FnButtonTypes, FnButtonVariants } from '../../../../components/elements/FnButton/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/pro-regular-svg-icons';
import { DivFilterTags, DivFilterTagsBlock, DivTag, DivTagClear } from './styles';
import {
  FilterType,
  TCurrentCheckboxListValue,
  TCurrentFilter,
  TCurrentFilterTextBoxValue,
  TFilter,
  TFilterTag
} from '../../../../commonTypes/filters';
import FnTag from '../../../../components/blocks/FnTag/index';
import { FnTagVariants } from '../../../../components/blocks/FnTag/constants';
import React, { FC, useEffect, useState } from 'react';
import { getCheckboxValueByTitle, getTagsByFilterType } from '../../utils';

interface Props {
  onSwitchFilter: () => void;
  onClearAllFilters: () => void;
  filters: TFilter[];
  currentFilterItems: TCurrentFilter[];
  onSetFilter: (data: TCurrentFilter) => void;
  onClearFilter: (data: string) => void;
}

export const Tags: FC<Props> = ({
  onSwitchFilter,
  onClearAllFilters,
  filters,
  currentFilterItems,
  onSetFilter,
  onClearFilter
}) => {
  const [tags, setTags] = useState([]);

  const handleClearFilter = (tag: Record<string, unknown>) => {
    const filterTag = tag as TFilterTag;
    if (
      filterTag.type === FilterType.TextBox ||
      filterTag.type === FilterType.CheckBoxList ||
      filterTag.type === FilterType.CheckBoxTreeList
    ) {
      const checkboxValues = currentFilterItems.find((item) => item.internalName === filterTag.internalName).values;
      const newCheckboxValues =
        filterTag.type === FilterType.TextBox
          ? (checkboxValues as Array<string>).filter((value: string) => value !== filterTag.name)
          : (checkboxValues as Array<number>).filter(
              (value: number) => value !== getCheckboxValueByTitle(filters, filterTag.internalName, filterTag.name)
            );

      if (newCheckboxValues.length) {
        const newFilterItem = {
          internalName: filterTag.internalName,
          values: [...newCheckboxValues] as TCurrentFilterTextBoxValue | TCurrentCheckboxListValue
        };
        onSetFilter(newFilterItem);
      } else {
        onClearFilter(filterTag.internalName);
      }
    } else {
      onClearFilter(filterTag.internalName);
    }
  };

  useEffect(() => {
    const newTags = currentFilterItems.map((currentFilter) => {
      const filterType = filters.find((item) => item.internalName === currentFilter.internalName).filterTypeName;
      return getTagsByFilterType(currentFilter, filters, filterType);
    });
    setTags([...newTags.flat()]);
  }, [currentFilterItems]);

  return (
    <DivFilterTagsBlock>
      <FnButton
        viewType={tags.length ? FnButtonTypes.Default : FnButtonTypes.Outline}
        variant={FnButtonVariants.Secondary}
        text="Filter"
        startIcon={<FontAwesomeIcon icon={faFilter} />}
        onClick={onSwitchFilter}
      />
      <DivFilterTags>
        {tags.map((tag: TFilterTag) => (
          <DivTag key={`${tag.name}${tag.internalName}`}>
            <FnTag
              variant={FnTagVariants.Outline}
              data={tag}
              labelProp="name"
              onClick={(item: Record<string, unknown>) => handleClearFilter(item)}
            />
          </DivTag>
        ))}
        {!!tags.length && (
          <DivTagClear>
            <FnButton
              size={FnButtonSizes.Small}
              viewType={FnButtonTypes.Text}
              text="Clear All Filters"
              onClick={onClearAllFilters}
            />
          </DivTagClear>
        )}
      </DivFilterTags>
    </DivFilterTagsBlock>
  );
};
